// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__14yt-","modalForm":"UpgradeEpcsModal_modalForm__1XJyv","modalFooter":"UpgradeEpcsModal_modalFooter__19hke"};